<template>
  <div>
    <iframe v-if="src" id="commonIframe" class="common-iframe" :src="src"></iframe>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi';

export default {
  data() {
    return {
      src: '',
    };
  },
  mounted() {
    this.src = this.$route.query.src ? `${this.$route.query.src}?token=${window.sessionStorage.getItem('dingdingAuth')}` : '';
    window.addEventListener('message', e => {
      // 资产服务二维码
      if (e.data.qrcode) {
        const myframe = document.getElementById('commonIframe');
        dd.biz.util.scan({
          type: 'all',
          onSuccess: data => {
            console.log(data);
            myframe.contentWindow.postMessage(data, this.src);
          },
          onFail: err => {
            console.log(err);
            myframe.contentWindow.postMessage(err, this.src);
          },
        });
      }
    });
  },

};
</script>
<style lang="scss" scoped>
.common-iframe {
  height: 100vh;
  width: 100vw;
  border: none;
}
</style>